export const UserRoles = {
	ADMIN: "ADMIN",
	MANAGER: "MANAGER",
	STOREKEEPER: "STOREKEEPER",
	DRIVER: "DRIVER",
};
